import {
  initialize, isFeatureEnabled, updateContext, getVariant,
} from './unleash'

function UnleashProxyPlugin(Vue, options) {
  const {
    url, // Unleash proxy URL
    clientKey, // Client key for the Unleash proxy
    appName, // Name of your application
    refreshInterval, // Optional: How often the toggles should be fetched from the server (in ms)
    environment, // Optional: Environment (like 'production', 'development')
  } = options

  // Initialize the Unleash proxy client
  initialize({
    url,
    clientKey,
    appName,
    refreshInterval,
    environment,
  })

  // unleashClient.updateContext({ userId: '123' }) // Optional: Set user context if needed
  // unleashClient.start()

  // Register a global mixin to inject a method for checking feature toggles
  Vue.mixin({
    methods: {
      isFeatureEnabled(featureName) {
        return isFeatureEnabled(featureName)
      },
      getVariant(featureName) {
        return getVariant(featureName)
      },
      updateFeatureContext(context) {
        return updateContext(context)
      },
    },
  })
}

export default UnleashProxyPlugin
